import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import LoadingOverlay from "react-loading-overlay-ts";
import PageLayout from "../../PageLayout";
import TaskHeader from "../DesignJobs/TaskHeader";
import { Toast } from "primereact/toast";

import { saveDesignIntent } from "../../../apis/designIntentApi";
import { deleteFileGroup } from "../../../apis/sharedFolderApi";
import { useDispatch, useSelector } from "react-redux";
import { getTaskDetails } from "../../../store/actions/taskDetailAction";
import "../DesignJobs/index.scss";
import { useParams } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import CloneJobs from "../DesignJobs/CloneJobs";
import { uploadtoAzureStrContainer } from "../../../apis/uploadAzuerContainer";

import CDHeader from "../DesignJobs/CDHeader";
import { submitConfirmPrintTrial } from "../../../apis/colorDevelopmentApi";

import {
  orderBySequence,
  onFileUpload as fileOnFileUpload,
  onFileClear as fileOnFileClear,
  addNewFiles as fileAddNewFiles,
  getFilesListObj as fileGetFilesListObj,
  onFileClearHandler,
  onAddNewFilesHandler,
  onSubmitHandler,
  onSubmitNavigationPath,
} from "../../../Utils/FileUploadService";

import IQCDFooterButtons from "../DesignJobs/IQCDFooterButtons";
import useAzureUploadFolderStructure from "../../../hooks/useAzureUploadFolderStructure";
import { AzureContainerFail, AzureContainerSuccess } from "../../../Utils/constants";
import { SpecialProjectAction } from "../../../store/actions/ProjectSetupActions";
import { redirectUnallocatedLinksToArtworkStatus } from "../../../utils";
import { UnsavedChangesDialog, useUnsavedChangesWarning } from "../../common/NavigationPrompt";
import UnAuthorizedComponent from "../../UnAuthorized/UnAuthorizedComponent";
import { getReadWriteAccessForTask, getUserAccessForTask } from "../../../Utils/helpers";
import _ from "lodash";

const breadcrumb = [{ label: "Confirm Color Development & Print Trial" }];

const headerName = "Confirm Color Development & Print Trial";
const jobName = "Confirm_PT_";

function CPT() {
  const toast = useRef(null);
  const dispatch = useDispatch();
  const { TaskDetailsData, loading } = useSelector((state) => state.TaskDetailsReducer);

  const BU = TaskDetailsData?.ArtworkAgilityTasks?.[0]?.BU;
  const projectName = TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Project_Name;

  const [data, setData] = useState(null);
  const [CD, setCD] = useState([]);
  const [taskStatus, setTaskStatus] = useState("");
  const [formValid, setFormValid] = useState(true);
  const [cptFormValid, setCptFormValid] = useState(true);
  const [updated, setUpdated] = useState(false);
  const [submittedDI, setSubmittedDI] = useState([]);
  const [formattedValue, setformattedValue] = useState(0);
  const [fileName, setFileName] = useState("");
  const [azureFile, setAzureFile] = useState("");
  const [loader, setLoader] = useState(true);
  const [version, setVersion] = useState(0);
  const [date, setDate] = useState("");
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  let { page1, page2, pageType, TaskID, ProjectID } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const locationPath = location?.pathname;

  // const checkReadWriteAccess = true;
  const {
    userDetails: { UserGroup },
  } = useSelector((state) => state?.UserDetailsReducer);
  const User = useSelector((state) => state.UserReducer);
  const userInformation = User?.userInformation;
  const userAccessPayLoad = {
    ArtworkAgilityPage: {
      UserId: userInformation?.userid,
      ProjectID: ProjectID,
      UserGroup: UserGroup,
    },
  };
  const [accessSecurityMatrix, setUserAccess] = useState(false);
  const [checkReadWriteAccess, setCheckReadWriteAccess] = useState(false);

  const AzureSubFolder = "PT";
  const folderStructure = useAzureUploadFolderStructure("PT", "", false);

  const [FormObjects, setFormObjects] = useState({
    Printer: [],
    Pantone: "",
    Select: false,
    Substrate: "",
    FileDetails: [],
    CD_Approved: false,
    Additional_Info: "",
    Printing_Process: "",
    Print_Trial_Done: false,
    IDDSampleApproved: false,
    Print_Trial_Needed: false,
    IDDSampleLabTestApproved: false,
  });
  const [pageEdited, setPageEdited] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [dropDownMatch, setDropDownMatch] = useState(true);
  const { markDirty, markClean } = useUnsavedChangesWarning();
  const [InitialFormObjects, setInitialFormObjects] = useState({
    Printer: [],
    Pantone: "",
    Select: false,
    Substrate: "",
    FileDetails: [],
    CD_Approved: false,
    Additional_Info: "",
    Printing_Process: "",
    Print_Trial_Done: false,
    IDDSampleApproved: false,
    Print_Trial_Needed: false,
    IDDSampleLabTestApproved: false,
  });

  const [taskDetails, setTaskDetails] = useState(null);
  const [initialTaskDetails, setInitialTaskDetails] = useState(null);
  const [documentSequence, setDocumentSequence] = useState(1);
  const [fileGroups, setFileGroups] = useState([]);

  useEffect(() => {
    const isObjectEqual = JSON.stringify(InitialFormObjects) === JSON.stringify(FormObjects);
    if (!isObjectEqual) {
      setPageEdited(true);
    } else {
      setPageEdited(false);
    }
  }, [FormObjects]);

  useEffect(() => {
    if (pageEdited) {
      markDirty();
    } else {
      markClean();
    }
  }, [pageEdited]);

  useEffect(() => {
    markClean();
    setPageEdited(false);
  }, []);

  useEffect(() => {
    setUserAccess(getUserAccessForTask(TaskDetailsData));
    setCheckReadWriteAccess(getReadWriteAccessForTask(TaskDetailsData));
  }, [TaskDetailsData?.AccessType]);

  useEffect(() => {
    if (userInformation?.userid && UserGroup?.length) {
      let taskId;
      if (TaskID) {
        taskId = TaskID.split("_")[1];
      }
      setLoader(false);
      dispatch(getTaskDetails(TaskID, ProjectID, userAccessPayLoad));
    }
  }, [dispatch, TaskID, ProjectID, userInformation?.userid, UserGroup?.length]);

  useEffect(() => {
    if (TaskDetailsData) {
      setCD(TaskDetailsData?.ArtworkAgilityTasks?.[0]?.DesignJobDetails || []);
      setData(TaskDetailsData?.ArtworkAgilityTasks?.[0] || []);
      setTaskStatus(TaskDetailsData?.ArtworkAgilityTasks[0]?.Task_Status);
      const data =
        TaskDetailsData?.ArtworkAgilityTasks?.[0]?.DesignJobDetails?.[0]?.FileMetaDataList?.[0] ||
        [];

      const grouped = Array.isArray(
        TaskDetailsData?.ArtworkAgilityTasks?.[0]?.DesignJobDetails?.[0]?.FileMetaDataList,
      )
        ? TaskDetailsData.ArtworkAgilityTasks[0].DesignJobDetails[0].FileMetaDataList
        : [];
      const fileGroupsResult = groupFilesByFileGroup(grouped);
      setFileGroups(fileGroupsResult);

      const specialProjectFlag = TaskDetailsData?.SpecialProject;
      dispatch(SpecialProjectAction(specialProjectFlag));
      redirectUnallocatedLinksToArtworkStatus(locationPath, specialProjectFlag, navigate);
      if (data) {
        data?.Version !== "" && setVersion(data.Version);
        data?.Timestamp !== "" &&
          setDate(moment(data.Timestamp, "YYYYMMDD[T]HHmmss.SSS [GMT]").format("DD-MMMM-YYYY"));
      }
      setDocumentSequence(fileGroupsResult?.length || 1);
    }
  }, [TaskDetailsData]);

  const handleCancel = () => {
    if (page2 && page2 === "projectPlan") {
      navigate(`/${page1}/${page2}/${TaskDetailsData?.ArtworkAgilityPage?.AWM_Project_ID}`);
    } else if (pageType) {
      navigate(`/${pageType}`);
    }
  };

  const handleCancelClick = () => {
    if (pageEdited) {
      setShowDialog(true);
    } else {
      handleCancel();
    }
  };

  // it will hide warning dialog
  const cancelNavigation = () => {
    setShowDialog(false);
  };
  // it will navigate to previously saved url navigate(pendingNavigation);
  // by doing setShowDialog(false) and setPendingNavigation("");
  const confirmNavigation = () => {
    markClean();
    handleCancel();
    setPageEdited(false);
    setShowDialog(false);
  };

  const addNewEmptyDesign = () => {
    const newDesignIntent = [
      ...CD,
      {
        Design_Job_ID: CD.length + 1,
        isNew: true,
        Print_Trial_Done: null,
        Tier: "",
        Cluster: "",
        Agency_Reference: "",
        Printer: [],
        Printing_Process: "",
        Design_Job_Name: "",
        Substrate: "",
        Additional_Info: "",
        CD_Approved: null,
        Select: null,
        Print_Trial_Needed: null,
      },
    ];
    setCD(newDesignIntent);
    setUpdated(!updated);
  };

  const addData = (fieldName, index, value) => {
    let data = CD[index];
    data[fieldName] = value;
    submittedDI.push(data);
    setSubmittedDI(submittedDI);
    checkFormValidity();
    if (fieldName === "Print_Trial_Done") {
      checkCPTFormValidity();
    }

    // if(value){
    setFormObjects((prev) => {
      return {
        ...prev,
        [fieldName]: value,
      };
    });
    // }
  };

  useEffect(() => {
    checkFormValidity();
    checkCPTFormValidity();
  }, [data]);

  useEffect(() => {
    if (
      (taskStatus !== "Complete" || taskStatus !== "Cancelled" || checkReadWriteAccess) &&
      (!fileGroups || fileGroups.length === 0)
    ) {
      const defaultFileGroup = [
        {
          FileGroup: 1,
          Sequence: 1,
          FileMetaDataList: [
            {
              isNew: true,
              FileGroup: 1,
              Sequence: 1,
              File_Name: "",
              Version: 1,
              Email: "",
              FileID: "",
              File_Path: "",
              Full_Name: "",
              JobID: "",
              JobName: "",
              ReadOnlyURL: "",
              Timestamp: "",
              TypeOfFile: "",
            },
          ],
        },
      ];
      setFileGroups(defaultFileGroup);
    }
  }, [fileGroups, taskStatus, checkReadWriteAccess]);

  function groupFilesByFileGroup(data) {
    const filtered = data.filter((f) => f.FileGroup !== "" && f.FileGroup !== undefined);
    // Group by FileGroup
    const grouped = filtered.reduce((acc, file) => {
      if (!acc[file.FileGroup]) acc[file.FileGroup] = [];
      acc[file.FileGroup].push(file);
      return acc;
    }, {});

    // Build the output array
    return Object.entries(grouped).map(([FileGroup, files]) => {
      // Find the max Sequence in this group
      const maxSequence = Math.max(...files.map((f) => Number(f.Sequence)));
      // Ensure cleanedFiles includes FileGroup and Sequence
      let cleanedFiles = files.map((file) => ({
        ...file,
        FileGroup: file.FileGroup,
        Sequence: file.Sequence,
      }));
      // Sort by Version descending (highest version first)
      cleanedFiles = cleanedFiles.sort((a, b) => Number(b.Version) - Number(a.Version));
      return {
        FileGroup,
        Sequence: maxSequence,
        FileMetaDataList: cleanedFiles,
      };
    });
  }

  const checkCPTFormValidity = () => {
    const validTasks = CD?.filter((task) => {
      return task?.Print_Trial_Done && task?.CD_Approved;
    });
    if (validTasks.length > 0) {
      setCptFormValid(true);
    } else {
      setCptFormValid(false);
    }
  };

  const checkFormValidity = () => {
    const validTasks = CD?.filter((task) => {
      return task?.Printer && task?.Printing_Process && task?.Substrate && task?.CD_Approved;
    });
    if (validTasks.length > 0) {
      setFormValid(true);
    } else {
      setFormValid(false);
    }
  };

  const onSelectAll = (checked) => {
    CD?.map((task) => {
      if (task?.Event !== "submit") {
        task.Select = checked;
      }
      return task;
    });
    setCD(CD);
    setUpdated(!updated);
  };

  const onFileUpload = (e, FileDetails, fileUploadSection, seq) => {
    const fileGroup = FileDetails?.FileGroup != null ? String(FileDetails.FileGroup) : undefined;
    const groupDetails = fileGroups.find((group) => String(group.FileGroup) === String(fileGroup));
    // Pass groupDetails.FileMetaDataList directly if needed, or just use fileGroups
    fileOnFileUpload(
      e,
      FileDetails,
      fileUploadSection,
      seq,
      groupDetails ? groupDetails : [],
      setFileGroups,
      orderBySequence,
    );
  };

  const onFileClear = async (fileUploadSection, fileListToRemove) => {
    const { apiCall, updatedGroups } = onFileClearHandler(
      fileListToRemove,
      fileGroups,
      setFileGroups,
      setLoader,
      {
        deleteFileGroupAPI: deleteFileGroup,
        ProjectID,
        TaskID: data.Task_ID,
        Etag: TaskDetailsData?.ArtworkAgilityPage?.Etag,
      },
    );

    if (apiCall) {
      try {
        await apiCall;
      } catch (error) {
        setLoader(false);
        return;
      }
    }

    setFileGroups(updatedGroups);
    setLoader(false);
  };

  const addNewFiles = (isNew = false) => {
    onAddNewFilesHandler(fileGroups, setFileGroups, setDocumentSequence);
  };

  const getFilesListObj = async () => {
    return await fileGetFilesListObj(
      fileGroups,
      TaskDetailsData,
      folderStructure,
      toast,
      uploadtoAzureStrContainer,
      AzureContainerSuccess,
      AzureContainerFail,
    );
  };

  // Reusable function to create formData, id, and headers for CPT submit/delete
  const getCPTFormData = (fileItems) => {
    const formData = {
      caseTypeID: "PG-AAS-Work-ConfirmColorDevelopmentDone",
      content: {
        AWMTaskID: data?.Task_ID,
        AWMProjectID: ProjectID,
        DesignJobID: CD?.[0]?.Design_Job_ID,
        CDApproved: CD?.[0]?.CD_Approved,
        PrintTrialDone: CD?.[0]?.Print_Trial_Done,
      },
      pageInstructions: fileItems.map((fileItem) => ({
        instruction: "APPEND",
        target: "ConfirmPTList",
        content: fileItem,
      })),
    };
    const id = data?.Task_Key;
    const headers = {
      key: "If-Match",
      value: TaskDetailsData?.ArtworkAgilityPage?.Etag,
    };
    return { formData, id, headers };
  };

  const onSubmit = async () => {
    const navigationPath = onSubmitNavigationPath(page1, page2, pageType, TaskDetailsData);
    await onSubmitHandler(
      getFilesListObj,
      getCPTFormData,
      submitConfirmPrintTrial,
      navigationPath,
      setLoader,
      navigate,
    );
  };

  const onSaveAsDraft = async () => {
    let submitOnlySelectedData = CD?.map((task) => {
      task.Action = "update";
      if (task?.Action !== "delete" && task?.Design_Job_ID) {
        task.Action = "update";
      } else if (task?.Action !== "delete" && task?.isNew === true) task.Action = "add";

      if (task?.isNew) {
        task.Design_Job_ID = "";
      }

      task.Event = "draft";
      task.AWM_Project_ID = "A-1000";
      return task;
    });
    let formData = {
      DesignIntentList: submitOnlySelectedData,
    };

    await uploadtoAzureStrContainer(azureFile, folderStructure);
    await saveDesignIntent(formData);
  };

  return (
    <PageLayout>
      <Toast ref={toast} />
      {loader || loading || CD === null ? (
        <LoadingOverlay
          active={loader || loading || CD === null}
          spinner
          text=""
          className="overlay-loader"
        />
      ) : accessSecurityMatrix ? (
        <>
          <CDHeader
            setAddNewDesign={addNewEmptyDesign}
            onSelectAll={onSelectAll}
            breadcrumb={breadcrumb}
            headerName={headerName}
            label="Confirm Color Development & Print Trial"
            disabled={true}
            checkReadWriteAccess={checkReadWriteAccess}
            data={data}
            lastLabel={"CPT"}
            pageEdited={pageEdited}
            setPageEdited={setPageEdited}
            showFilterHeaders={true}
          />
          <div className="task-details">
            {
              <TaskHeader
                {...data}
                TaskDetailsData={TaskDetailsData}
                pageEdited={pageEdited}
                setPageEdited={setPageEdited}
              />
            }
            {/* {data?.Task_Status === "Complete" && (
            <div className="task-completion">This task is already submitted</div>
          )} */}
            {CD &&
              CD.length > 0 &&
              CD.map((item, index) => {
                if (item && item?.Action !== "delete") {
                  return (
                    <CloneJobs
                      key={index}
                      {...data}
                      CD={CD}
                      data={data}
                      item={item}
                      setFormObjects={setFormObjects}
                      setInitialFormObjects={setInitialFormObjects}
                      AWMProjectID={TaskDetailsData?.ArtworkAgilityPage?.AWM_Project_ID}
                      AWMTaskID={TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Task_ID}
                      Bu={TaskDetailsData?.ArtworkAgilityTasks?.[0]?.BU}
                      Region={TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Region}
                      hideClearButton={false}
                      index={index}
                      addData={addData}
                      setDropDownMatch={setDropDownMatch}
                      jobName={jobName}
                      formValid={formValid}
                      setFormValid={setFormValid}
                      setformattedValue={setformattedValue}
                      setAzureFile={setAzureFile}
                      setFileName={setFileName}
                      fileName={fileName}
                      version={version}
                      date={date}
                      pageEdited={pageEdited}
                      setPageEdited={setPageEdited}
                      checkReadWriteAccess={checkReadWriteAccess}
                      Artwork_Brand={TaskDetailsData?.ArtworkAgilityPage?.Artwork_Brand}
                      Artwork_Category={TaskDetailsData?.ArtworkAgilityPage?.Artwork_Category}
                      azureSubFolder={AzureSubFolder}
                      Taskdata={TaskDetailsData}
                      onFileUpload={onFileUpload}
                      onFileClear={onFileClear}
                      addNewFiles={addNewFiles}
                      taskDetails={taskDetails}
                      taskStatus={taskStatus}
                      fileGroups={fileGroups}
                    />
                  );
                }
              })}
          </div>
          <IQCDFooterButtons
            handleCancel={handleCancelClick}
            onSaveAsDraft={onSaveAsDraft}
            onSubmit={onSubmit}
            formValid={!formValid}
            pageEdited={pageEdited}
            setPageEdited={setPageEdited}
            cptFormValid={cptFormValid}
            checkReadWriteAccess={checkReadWriteAccess}
            bottomFixed={true}
            data={data}
          />
          {/* UnsavedChangesDialog popup*/}
          <UnsavedChangesDialog
            visible={showDialog}
            onCancel={cancelNavigation}
            onConfirm={confirmNavigation}
          />
        </>
      ) : (
        <UnAuthorizedComponent nowrapper={true} />
      )}
    </PageLayout>
  );
}

export default CPT;
